/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_My_Dashboard_TitleInputs */



/**
* | output |
* | --- |
* | "My Dashboard" |
*
* @param {Dashboard_My_Dashboard_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_my_dashboard_title = /** @type {((inputs?: Dashboard_My_Dashboard_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_My_Dashboard_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mein Dashboard")
	return /** @type {LocalizedString} */ ("My Dashboard")
});